<!--
 * @Author: 李明明
 * @Date: 2022-09-14 17:26:10
 * @LastEditTime: 2024-12-10 09:41:57
 * @LastEditors: 李明明
 * @Description: 
 * @FilePath: /ykt-micro-main/src/views/courseDetail/index.vue
 * 代码版权方：'政府采购信息网'
-->
<template>
  <div ref="homePage" class="detail_wrap">
    <!-- 付费弹窗 -->
    <!-- 人脸识别未通过弹窗 -->
    <el-dialog v-model="buyDialogVisible" title="提示" width="400px" center>
      <span style="display: block; text-align: center; padding: 25px;">免费视频已看完，购买课程继续观看吧</span>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="enroll"> 立即购买 </el-button>
        </span>
      </template>
    </el-dialog>
    <!-- 人脸识别照片确认弹窗 -->
    <el-dialog v-model="faceImageVisible" title="免冠证件照确认" width="650px" :before-close="handleClose"
      :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" center>
      <div class="pic_virify">
        <div class="pic_wrap">
          <div class="pic">
            <el-upload class="upload" action="#" :show-file-list="false" accept=".JPG,.PNG,.jpg,.png,.jpeg"
              :http-request="httpRequest">
              <div class="upload-wrap">
                <img :src="verifyImg" alt="" v-if="verifyImg" class="verify_img" />
                <i class="iconfont iconren111" v-else></i>
                <div class="upload_pic">
                  <el-icon>
                    <Plus />
                  </el-icon>
                  <p>上传照片</p>
                </div>
              </div>
            </el-upload>
            <el-upload action="#" :show-file-list="false" accept=".JPG,.PNG,.jpg,.png,.jpeg"
              :http-request="httpRequest">
              <p class="reupload">修改照片</p>
            </el-upload>
            <p class="require">
              <span> 照片要求 </span>
              <el-tooltip class="box-item" effect="dark" placement="right">
                <template #content>
                  <p>2寸白底，免冠证件照</p>
                  <p>仅支持jpg、png格式，小于5MB</p>
                </template>
                <el-icon>
                  <WarningFilled />
                </el-icon>
              </el-tooltip>
            </p>
          </div>
        </div>
        <div class="pic_tip">
          <p>注意：</p>
          <p>免冠证件照用于培训证书及人脸识别身份核验；</p>
          <p>一经确认无法变更，请仔细核对！</p>
          <p>学习过程中将进行人脸识别校验，未通过校验「无法继续参加学习」！</p>
          <p style="color: #df3031; margin-top: 16px">
            提示：请确保摄像头已正常连接并开启。
          </p>
        </div>
      </div>
      <template #footer>
        <span class="dialog-footer" style="margin-top: 30px; display: inline-block">
          <el-button @click="ExitStudy">退出学习</el-button>

          <el-button type="primary" @click="GoFaceVerify">
            开始人脸识别
          </el-button>
        </span>
      </template>
    </el-dialog>
    <!-- 人脸识别未通过弹窗 -->
    <el-dialog v-model="faceFailedVisible" title="提示" width="600px" center :close-on-click-modal="false"
      :close-on-press-escape="false" :show-close="false">
      <span style="display: block; text-align: center">准备进行人脸识别校验，未通过校验「无法继续参加学习！」</span>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="ExitStudy">退出学习</el-button>
          <el-button type="primary" @click="GoFaceVerify">
            开始人脸识别
          </el-button>
        </span>
      </template>
    </el-dialog>
    <div class="go_exam_mask" v-if="go_exam_show">
      <div class="exam_img">
        <img src="@/assets/images/exam_mask.png" alt />
        <div class="btn_wrap">
          <template v-if="formInfoData.isSubmit == 0">
            <el-button type="danger" size="small" @click="go_form" v-if="formData.isOpenForm" plain>学情反馈</el-button>
          </template>

          <el-button type="danger" size="small" @click="go_exam">参加考试</el-button>
        </div>

        <i class="iconfont iconyiliaohangyedeICON- go_exam_guanbi" @click="go_exam_show = false"></i>
      </div>
    </div>
    <!-- 随堂小考弹窗 -->
    <Test :anchor_list="anchor_list" :testShow="testShow" :currentVideoData="currentVideoData" v-if="currentVideoData"
      @sign="signTest($event)"></Test>
    <div class="wrap" id="course_wrap">
      <div class="course_header">
        <Notice v-if="noticeShow" :noticeData="noticeData"></Notice>
        <el-tooltip class="box-item" effect="dark" :content="courseData.courseName" placement="top">
          <h3 class="course_title">{{ courseData.courseName }}</h3>
        </el-tooltip>
        <el-dropdown class="phone_btn">
          <span class="el-dropdown-link">
            <el-button type="primary">
              手机观看
              <el-icon style="margin-left: 6px">
                <ArrowDown />
              </el-icon>
            </el-button>
          </span>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item>
                <p>下载易采通App</p>
                <div>
                  <img class="xcx_img" src="@/assets/images/yct.png" />
                </div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
      <!-- 学习区域 -->
      <div class="course_left">
        <!-- 视频播放区域 -->
        <div class="video_center" ref="video_center">
          <div class="perch"></div>
          <div class="video_container" ref="video_container" :class="[isPicture ? 'pictureVideo' : 'noPictureVideo']"
            v-drag>
            <!-- 遮罩 -->
            <div class="video_mask" v-if="maskType">
              <div class="mask_btn_wrap">
                <el-button type="primary" @click="player.play()">重新播放</el-button>
                <el-button type="primary" @click="nextVideo" :disabled="videoDisabled">下一节课</el-button>
              </div>
            </div>
            <div class="perch_drag" v-if="drawShow">
              <i class="iconfont" :class="[videoState == 2 ? 'iconzanting1' : 'iconzanting2']" @click="handleVideo()"
                v-if="faceState == 2"></i>
              <i class="iconfont iconzanting1" v-else></i>
            </div>
            <div class="buy_tips" v-if="courseData.course.yxbType == 8 && !courseData.enrollStatus">
              试看中，购买课程后可完整观看
              <span @click="enroll">立即购买</span>
            </div>
            <div id="ccVideo" class="ccVideo"></div>
          </div>
          <el-alert type="info" v-if="courseData.copyright">
            <marquee style="font-size: 16px" behavior direction scrollamount="10"
              v-if="courseData.copyright.length >= 40">
              {{ courseData.copyright }}</marquee>
            <span v-else style="font-size: 16px">{{
              courseData.copyright
            }}</span>
          </el-alert>
          <div class="course_handle">
            <!-- 显示小程序二维码 -->
            <el-dropdown class="go_exam video_bo_btn">
              <div>
                <i style="font-size: 16px; vertical-align: middle" class="iconfont iconweibiaoti2fuzhi07"></i>
                <span>手机观看</span>
              </div>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item>
                    <p>下载易采通App</p>
                    <img class="xcx_img" src="@/assets/images/yct.png" />
                  </el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
            <!-- 参加考试 -->
            <template v-if="courseData.course.yxbType != 8">
              <div class="go_exam video_bo_btn" @click="go_exam" v-if="courseData.examCount > 0">
                <i class="iconfont iconkaoshi1"></i>
                <span>参加考试</span>
              </div>
            </template>
            <template v-else>
              <div class="go_exam video_bo_btn" @click="go_exam"
                v-if="courseData.examCount > 0 && courseData.enrollStatus == 1">
                <i class="iconfont iconkaoshi1"></i>
                <span>参加考试</span>
              </div>
            </template>
            <!-- 资料下载 -->
            <div class="go_download video_bo_btn" @click="goDownload" v-if="courseData.batchDownloadMaterialUrl">
              <el-icon>
                <Download />
              </el-icon>
              <span>资料下载</span>
            </div>
            <template v-if="formData.formId != ''">
              <!-- 学情反馈表单 -->
              <el-tooltip class="item" effect="dark" :content="'学情反馈 - ' + formInfoData.formTitle"
                v-if="formData.isOpenForm" placement="top">
                <div class="go_exam video_bo_btn" @click="go_form">
                  <i class="iconfont iconwenjiansousuo"></i>
                  <span>学情反馈</span>
                </div>
              </el-tooltip>
            </template>
            <!-- 是否显示随堂小考 -->
            <div class="tesring_wrap video_bo_btn" v-if="proData.isOpenUserCloseAnchor">
              <label>{{
                proData.closeAnchorStatus ? "开启随堂小考" : "关闭随堂小考"
              }}</label>
              <el-switch @change="ChangeTesting" v-model="proData.closeAnchorStatus" :active-value="1"
                :inactive-value="0">
              </el-switch>
            </div>
            <!-- 免费课程购买 -->
            <div class="free_wrap" v-if="courseData.course.yxbType == 8 && !courseData.enrollStatus">
              <el-button type="primary" @click="enroll">立即购买</el-button>
            </div>
            <!-- 开启自动续播 -->
            <div class="auto_wrap" v-if="courseData.isAutomaticPlayVideo == 1">
              <label>{{
                courseData.chooseAutomaticPlayVideo
                  ? "开启自动续播"
                  : "关闭自动续播"
              }}</label>
              <el-switch @change="ChangeVideoSnap" v-model="courseData.chooseAutomaticPlayVideo" :active-value="1"
                :inactive-value="0">
              </el-switch>
            </div>
          </div>
        </div>
        <!-- 视频学习相关信息 -->
        <div class="video_info">
          <!-- 课程目录 -->
          <div class="video_list">
            <p class="video_list_title">课程目录</p>
            <el-collapse v-model="activeName" accordion @change="collChange">
              <el-collapse-item :name="index"
                :class="item.freeVideoCount <= 0 && courseData.course.yxbType == 8 && !courseData.enrollStatus ? 'hide-open-icon' : ''"
                :data="index" v-for="(item, index) in courseData.columnList" :key="index">
                <template #title>
                  <i class="iconfont iconzhangjie zhangjie"></i>
                  <el-tooltip class="box-item" effect="dark" placement="top">
                    <template #content>
                      <p>{{ item.onlineColumnName }}</p>
                    </template>
                    <span class="video_title" :class="[classTestType == 3 ? 'title_lone' : '']">
                      <span>
                        {{ item.onlineColumnName }}
                      </span>
                    </span>
                  </el-tooltip>
                  <span class="video_state exam" v-if="classTestType != 3">随堂小考</span>
                  <template v-if="courseData.course.yxbType == 8 && item.isFree">
                    <span class="video_state">
                      <div class="free_tag ">试看</div>
                    </span>

                  </template>
                  <template v-else>
                    <span class="video_state learn" v-if="item.finishedStatus == 1">已学完</span>
                    <span class="video_state learn" v-else>未学完</span>
                  </template>

                </template>
                <ul class="chapter_list">
                  <template v-for="(videoItem, videoIndex) in dataArticleList" :key="videoIndex">
                    <li class="patch" v-if="videoItem.conduct" @click="
                      changeVideo(
                        videoItem,
                        true,
                        dataArticleList,
                        videoIndex
                      )
                      ">
                      <div class="list_wrap" :class="[
                        classTestType == 3 ? 'chapter_title_lone' : '',
                      ]">
                        <span class="chapter_title">
                          <template v-if="faceState == 2">
                            <img v-if="videoState == 1" src="@/assets/images/player.gif" alt />
                            <img v-else src="@/assets/images/icon.png" alt />
                          </template>
                          <template v-else>
                            <img src="@/assets/images/icon.png" alt />
                          </template>

                          {{ videoItem.articleTitle }}
                        </span>
                        <i class="iconfont icon-video" v-if="videoItem.online_date_type == 1"></i>
                        <i class="iconfont icon-16" v-else-if="videoItem.online_date_type == 2"></i>
                        <i class="iconfont icon-14" v-else-if="videoItem.online_date_type == 4"></i>
                        <i class="iconfont icon-yinliang" v-else-if="videoItem.online_date_type == 3"></i>
                        <!-- 是否为试看 -->
                        <template v-if="videoItem.isFree">
                          <div class="free_tag">试看</div>
                        </template>
                        <template v-else>
                          <i v-if="
                            courseData.course.yxbType == 8 &&
                            !courseData.enrollStatus
                          " class="iconfont iconsuoding_huaban lock"></i>
                        </template>
                      </div>
                      <template v-if="classTestType != 3">
                        <span v-if="videoItem.isFree" class="video_state exam">--</span>
                        <template v-else>
                          <span v-if="videoItem.online_date_type == 1" class="video_state exam">
                            <template v-if="videoItem.questionTotalCount > 0">
                              已答：{{ videoItem.questionFinishCount }}/{{
                                videoItem.questionTotalCount
                              }}
                            </template>
                            <template v-else>
                              --
                            </template>
                          </span>
                          <span v-else class="video_state exam">/</span>
                        </template>
                      </template>
                      <span class="video_state learn">
                        <span v-if="videoItem.isFree" class="video_state exam">--</span>
                        <el-progress v-else type="circle" :percentage="(
                          (currentVideoData.playTime /
                            currentVideoData.totalTime) *
                          100
                        ).toFixed(1)
                          " width="36" :stroke-width="2" style="vertical-align: middle">
                          <template #default="{ percentage }">
                            <span class="percentage-value" style="font-size: 12px">
                              <template v-if="
                                currentVideoData.playTime /
                                currentVideoData.totalTime >=
                                1
                              ">
                                <i class="iconfont iconduigou" style="color: #418ec6"></i>
                              </template>
                              <template v-else>
                                {{
                                  (
                                    (currentVideoData.playTime /
                                      currentVideoData.totalTime) *
                                    100
                                  ).toFixed(0)
                                }}%
                              </template>
                            </span>
                          </template>
                        </el-progress>
                      </span>
                    </li>
                    <li v-else @click="
                      changeVideo(
                        videoItem,
                        true,
                        dataArticleList,
                        videoIndex
                      )
                      ">
                      <div class="list_wrap" :class="[
                        classTestType == 3 ? 'chapter_title_lone' : '',
                      ]">
                        <span class="chapter_title">{{ videoIndex + 1 }}、{{
                          videoItem.articleTitle
                          }}</span>
                        <i class="iconfont icon-video" v-if="videoItem.online_date_type == 1"></i>
                        <i class="iconfont icon-16" v-else-if="videoItem.online_date_type == 2"></i>
                        <i class="iconfont icon-14" v-else-if="videoItem.online_date_type == 4"></i>
                        <i class="iconfont icon-yinliang" v-else-if="videoItem.online_date_type == 3"></i>
                        <!-- 是否为试看 -->
                        <template v-if="videoItem.isFree">
                          <div class="free_tag">试看</div>
                        </template>
                        <template v-else>
                          <i v-if="
                            courseData.course.yxbType == 8 &&
                            !courseData.enrollStatus
                          " class="iconfont iconsuoding_huaban lock"></i>
                        </template>
                      </div>
                      <template v-if="classTestType != 3">
                        <span v-if="videoItem.isFree" class="video_state exam">--</span>
                        <template v-else>
                          <span class="video_state exam" v-if="videoItem.online_date_type == 1">
                            <template v-if="videoItem.questionTotalCount > 0">
                              已答：{{ videoItem.questionFinishCount }}/{{
                                videoItem.questionTotalCount
                              }}
                            </template>
                            <template v-else>
                              --
                            </template>

                          </span>
                          <span v-else class="video_state exam">/</span>
                        </template>
                      </template>
                      <span class="video_state learn">
                        <span v-if="videoItem.isFree"> -- </span>
                        <el-progress v-else type="circle" :percentage="(
                          (videoItem.playTime / videoItem.totalTime) *
                          100
                        ).toFixed(1)
                          " width="36" :stroke-width="2" style="vertical-align: middle">
                          <template #default="{ percentage }">
                            <span class="percentage-value" style="font-size: 12px">
                              <template v-if="
                                videoItem.playTime / videoItem.totalTime >= 1
                              ">
                                <i class="iconfont iconduigou" style="color: #418ec6"></i>
                              </template>
                              <template v-else>
                                {{
                                  (
                                    (videoItem.playTime / videoItem.totalTime) *
                                    100
                                  ).toFixed(0)
                                }}%
                              </template>
                            </span>
                          </template>
                        </el-progress>
                      </span>
                    </li>
                  </template>
                </ul>
              </el-collapse-item>
            </el-collapse>
          </div>
          <!-- 调查问卷 -->
          <template v-if="formData.formId != ''">
            <div class="survey_wrap" @click="go_form" v-if="formData.isOpenForm">
              <p class="form_title">
                <i class="iconfont iconkaoshi"></i>
                <span>{{ formInfoData.formTitle }}</span>
              </p>
              <p class="form_state">调查问卷</p>
              <p class="form_state">
                {{ formInfoData.isSubmit ? "已完成" : "现在填写" }}
              </p>
            </div>
          </template>
          <!-- 选修课列表 -->
          <div class="take_list" v-if="takeColumnData.hasOptionalCourse">
            <p class="take_list_title">
              选修课程（<span>{{ takeColumnData.optionalCourseMessage }}</span>
              ）
            </p>
            <el-collapse v-model="takeName" accordion @change="takeCollChange">
              <el-collapse-item :name="index" :data="index" v-for="(item, index) in takeColumnData.columnList"
                :key="index">
                <template #title>
                  <i class="iconfont iconzhangjie zhangjie"></i>
                  <span class="video_title" :class="[classTestType == 3 ? 'title_lone' : '']">
                    {{ item.onlineColumnName }}
                  </span>
                </template>
                <ul class="chapter_list">
                  <template v-for="(videoItem, videoIndex) in takeArticleList" :key="videoIndex">
                    <li class="patch" v-if="videoItem.conduct" @click="
                      changeVideo(
                        videoItem,
                        true,
                        takeArticleList,
                        videoIndex
                      )
                      ">
                      <div class="list_wrap" :class="[
                        classTestType == 3 ? 'chapter_title_lone' : '',
                      ]">
                        <span class="chapter_title">
                          <template v-if="faceState == 2">
                            <img v-if="videoState == 1" src="@/assets/images/player.gif" alt />
                            <img v-else src="@/assets/images/icon.png" alt />
                          </template>
                          <template v-else>
                            <img src="@/assets/images/icon.png" alt />
                          </template>
                          {{ videoItem.articleTitle }}
                        </span>
                        <i class="iconfont icon-video" v-if="videoItem.online_date_type == 1"></i>
                        <i class="iconfont icon-16" v-else-if="videoItem.online_date_type == 2"></i>
                        <i class="iconfont icon-14" v-else-if="videoItem.online_date_type == 4"></i>
                        <i class="iconfont icon-yinliang" v-else-if="videoItem.online_date_type == 3"></i>
                      </div>
                    </li>
                    <li v-else @click="
                      changeVideo(
                        videoItem,
                        true,
                        takeArticleList,
                        videoIndex
                      )
                      ">
                      <div class="list_wrap" :class="[
                        classTestType == 3 ? 'chapter_title_lone' : '',
                      ]">
                        <span class="chapter_title">{{ videoIndex + 1 }}、{{
                          videoItem.articleTitle
                          }}</span>
                        <i class="iconfont icon-video" v-if="videoItem.online_date_type == 1"></i>
                        <i class="iconfont icon-16" v-else-if="videoItem.online_date_type == 2"></i>
                        <i class="iconfont icon-14" v-else-if="videoItem.online_date_type == 4"></i>
                        <i class="iconfont icon-yinliang" v-else-if="videoItem.online_date_type == 3"></i>
                        <i style="color: #999999" v-if="
                          courseData.course.yxbType == 8 &&
                          !courseData.enrollStatus
                        " class="iconfont iconsuoding_huaban lock"></i>
                      </div>
                    </li>
                  </template>
                </ul>
              </el-collapse-item>
            </el-collapse>
          </div>
        </div>
      </div>
      <!-- 课程信息区域 -->
      <div class="course_right">
        <!-- 音视频类模块 -->
        <div>
          <!-- 课程标题 -->
          <div class="course">
            <p class="course_title">{{ dataArticle.articleTitle }}</p>
          </div>
          <!-- 讲师简介 -->
          <div class="lecturer_present" v-if="lecturer">
            <div class="info">
              <div class="pic">
                <img :src="lecturer.image" alt />
              </div>
              <div class="news">
                <div class="name_wrap">
                  <span class="name">{{ lecturer.name }}</span>
                  <span class="tip">讲师</span>
                </div>
                <div></div>
                <el-popover placement="bottom" width="230px" trigger="hover" :content="lecturer.intro">
                  <template #reference>
                    <el-button size="small">讲师介绍</el-button>
                  </template>
                </el-popover>
              </div>
            </div>
          </div>
          <!-- 操作区 -->
          <div class="handle">
            <div class="title">{{ currentVideoData.article_title }}</div>
            <p class="hand_txt">课程时间：{{ dataArticle.articleVideoTime }}</p>
            <div class="hand_data" v-if="currentVideoData.isOptionalVideo != 1">
              <span class="topic" v-if="classTestType != 3">
                已答：
                <template v-if="currentVideoData.isFree">--</template>
                <template v-else>
                  <template v-if="currentVideoData.questionTotalCount > 0">
                    {{ currentVideoData.questionFinishCount }}/{{
                      currentVideoData.questionTotalCount
                    }}
                  </template>
                  <template v-else>
                    --
                  </template>


                </template>
              </span>
              <span class="rate_learn" v-if="currentVideoData.isFree">已学--</span>
              <template v-else>
                <span style="color: #5c90bf; font-weight: 900" class="rate_learn" v-if="
                  currentVideoData.playTime / currentVideoData.totalTime >= 1
                ">已学完</span>
                <span class="rate_learn" v-else>
                  已学

                  {{
                    (
                      (currentVideoData.playTime / currentVideoData.totalTime) *
                      100
                    ).toFixed(1)
                  }}%
                </span>
              </template>
            </div>
            <div class="handle_video">
              <el-button :type="info" link @click="lastVideo()" :disabled="videoDisabled" class="left">
                <i class="iconfont iconshangyiqu left"></i>
              </el-button>
              <el-button :type="info" link @click="handleVideo()" :disabled="videoDisabled" class="center">
                <i v-if="currentVideoData.online_date_type == 1" class="iconfont center"
                  :class="videoState == 1 ? 'iconzanting' : 'iconbofang11'" @click="handleVideo()"></i>
              </el-button>
              <el-button :type="info" link @click="nextVideo()" :disabled="videoDisabled" class="right">
                <i class="iconfont iconxiayiqu right" @click="nextVideo()" :disabled="videoDisabled"></i>
              </el-button>
            </div>
          </div>
        </div>
        <!-- 电子书广告位 -->
        <div class="advert_ebook" v-if="ebookShow">
          <img v-if="ebookImgType == 1" class="ebook" src="@/assets/images/ebook.jpg" alt="" />
          <img v-else-if="ebookImgType == 2" class="ebook" src="@/assets/images/ebook2.png" alt="" />
        </div>
        <!-- 广告位 -->
        <div class="advert">
          <img :src="item.advertIco" alt="" v-for="item in advertData" :key="item.id" @click="addClick(item)" />
        </div>
        <!-- 学习进度 -->
        <div class="speed">
          <div class="speend_title">
            <p class="speend_title_txt">进度概览</p>
          </div>
          <div class="circle_wrap" :class="[classTestType == 3 ? 'circle_wrap_no_test' : '']">
            <!-- 课程时长 -->
            <!-- <div class="progress_wrap learning_progress"> -->
              <!-- <h3 class="progress_title">总学时</h3>
              <div class="time_wrap">
                <div class="time_wrap" v-if="courseData.course.yxbType == 8 && !courseData.enrollStatus">
                  <span class="time">**</span>
                  <span class="time_txt">学时</span>

                </div>
                <div v-else class="time_wrap">
                  <span class="time_count">{{ courseData.frontShowTotalClassHour }}学时</span>
                </div> -->
                <!-- <div class="time_wrap" v-html="Filter.dateFormat2(proData.courseTotalTime, 2)" v-else></div> -->
              <!-- </div> -->
            <!-- </div> -->
            <!-- 视频学习进度 -->
            <div class="progress_wrap learning_progress">
              <h3 class="progress_title">
                <span style="
                      display: inline-block;
                      vertical-align: middle;">学习进度</span>
                <el-tooltip class="box-item" effect="dark" placement="right">
                  <template #content>
                    <p>学习已完成后即可参加考试</p>
                  </template>
                  <el-icon style="
                      display: inline-block;
                      vertical-align: middle;
                      margin-left: 4px;
                    ">
                    <Warning />
                  </el-icon>

                </el-tooltip>
              </h3>
              <div class="progress_content">
                <el-progress v-if="Duration <= 100" class="accuracy video_accuracy" type="circle" :percentage="Duration"
                  color="#ff9a88" :width="150">
                  <template #default="{ percentage }">
                    <div class="video_number">
                      <template v-if="learnFinish">
                        <p class="title" style="font-size:18px;">已学完</p>
                      </template>
                      <template v-else>
                        <p class="title">已学</p>
                        <p class="txt">{{ Duration }}%</p>
                      </template>
                    </div>
                  </template>
                </el-progress>

                <p class="ought_time" v-if="courseData.course.yxbType == 8 && !courseData.enrollStatus"></p>
                <!-- <p class="ought_time" v-else>
                  应学习：{{
                    proData.totalTime == 0
                      ? "0小时0分钟"
                      : Filter.dateFormat(proData.totalTime, 2)
                  }}
                </p> -->
                <p class="free_time" v-if="courseData.course.yxbType == 8">
                  * 免费课程（{{
                    proData.totalFreeVideoTime == 0
                      ? "0小时0分钟"
                      : Filter.dateFormat(proData.totalFreeVideoTime, 2)
                  }}）
                <p>不计入应学习时长</p>
                </p>
              </div>
            </div>
            <!-- 随堂小考答题进度 -->
            <template v-if="classTestType != 3">
              <div class="progress_wrap learning_progress" v-if="courseData.course.yxbType != 8">
                <h3 class="progress_title">
                  <span style="display: inline-block; vertical-align: middle">随堂小考</span>

                  <el-tooltip class="box-item" effect="dark" placement="right">
                    <template #content>
                      <p>学习过程中随机弹出考题</p>
                      <p>不答/答错不影响正式考试</p>
                    </template>
                    <el-icon style="
                      display: inline-block;
                      vertical-align: middle;
                      margin-left: 4px;
                    ">
                      <Warning />
                    </el-icon>
                  </el-tooltip>
                </h3>

                <div class="progress_content">
                  <el-progress v-if="Duration > 100" class="accuracy video_accuracy" type="circle" :show-text="false"
                    :percentage="100" color="#ff9a88" :width="150">
                  </el-progress>
                  <template v-if="classTestType != 3">
                    <el-progress v-if="pro_answer <= 100" class="accuracy answer_accuracy" type="circle"
                      :percentage="pro_answer" color="#ffa423" :width="150">
                      <template #default="{ percentage }">
                        <div class="answer_number" v-if="classTestType != 3">
                          <p class="title">
                            已答{{ proData.totalFinishQuestionCount }}题
                          </p>
                        </div>
                      </template>
                    </el-progress>
                    <el-progress v-if="pro_answer > 100" class="accuracy answer_accuracy" type="circle"
                      :show-text="false" :percentage="100" color="#ffa423" :width="150"></el-progress>
                  </template>
                  <p class="exam_number">共{{ proData.totalQuestionCount }}题</p>
                </div>
              </div>
            </template>

          </div>
          <template v-if="courseData.course.yxbType == 8 && !courseData.enrollStatus"></template>
          <div class="card" v-else>
            <p>距离培训结束剩余{{ proData.leftDay }}天</p>
            <p>请于结束前（{{ proData.studyEndDate }}）完成学习和考试</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- 右侧固定组件 -->
  <div class="flex_right">
    <div class="sub_wrap">
      <div class="heng"></div>
      <div class="go_top" @click="toTop">
        <i class="iconfont iconxiangshang"></i>
        <p>回顶部</p>
      </div>
    </div>
  </div>
  <!-- 图片裁剪弹窗 -->
  <el-dialog v-model="cropperModel" width="1100px">
    <Cropper :img-file="changeImg" ref="vueCropper" :fixedNumber="fixedNumber" @upload="confirmUpload"></Cropper>
  </el-dialog>
</template>

<script setup>
import Cropper from "@/components/cropper/index";

import * as Filter from "@/utils/filter";
import { onMounted, onUnmounted, ref, watch, nextTick, inject } from "vue";
import * as courseApi from "@/api/course";
import * as homeApi from "@/api/home";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import { ElMessage, ElMessageBox } from "element-plus";
import axios from "axios";
import qs from "qs";
import Test from "@/views/courseDetail/components/test";
import Notice from "@/components/public/notice";
import { ArrowDown, Download } from "@element-plus/icons-vue";
import { addClick } from "@/hooks/addClick.ts";
import {
  randomString,
  sha1Sign,
  splitJointUrl,
  getQueryStr,
} from "@/utils/utils";

const route = useRoute();
const router = useRouter();
const store = useStore();
const reload = inject("reload");

const videoDisabled = ref(false);
const classTestType = ref(1);
// 回顶部
const toTop = () => {
  let timer = setInterval(() => {
    document.documentElement.scrollTop -= 20;
    if (document.documentElement.scrollTop <= 0) {
      clearInterval(timer);
    }
  }, 30);
};

// 进入考试页面
const go_exam = () => {
  router.push({
    path: "/exam_list",
  });
};
// 获取课程章节数据
const signUpUserId = ref(""); // 学员ID
const onlineClassId = ref(""); // 课程ID
const courseId = ref(""); // 研修班ID
const courseData = ref({
  course: {
    yxbType: 0,
  },
}); // 课程数据
const activeName = ref(0); // 折叠面板数据
const isEnableFaceValidateInLearning = ref(0); // 是否开启人脸识别
const faceImageVisible = ref(false);
const faceFailedVisible = ref(false);
const faceValidatePosition = ref(""); // 人脸识别锚点
const AsyncListColumn = () => {
  const params = {
    signUpUserId: signUpUserId.value,
    onlineClassId: onlineClassId.value,
  };
  courseApi.listColumn(params).then((res) => {
    if (res.resCode == 200) {
      courseData.value = res.resData;
      isEnableFaceValidateInLearning.value =
        courseData.value.isEnableFaceValidateInLearning;
      faceValidatePosition.value = courseData.value.faceValidatePosition;

      AsyncListProcess();
      AsyncListColumnOptionalCourse();

      // 需要进行人脸识别
      if (faceValidatePosition.value) {

        if (localStorage.getItem("orderNo")) {
          AsyncVerifyStudyFaceResult();
        } else {
          if (faceValidatePosition.value[0] == 0) {
            const params = {
              studentId: signUpUserId.value,
            };
            courseApi.getStudentInfo(params).then((res) => {
              if (res.resCode == 200) {
                verifyImg.value = res.resData.img;
                faceImageVisible.value = true;
              }
            });
          }
        }
      }
      // 用户无播放记录，从第一个视频开始播放
      if (!courseData.value.lastColumnId) {
        if (
          courseData.value.course.yxbType == 8 &&
          !courseData.value.enrollStatus
        ) {
          for (let i = 0; i < courseData.value.columnList.length; i++) {
            if (courseData.value.columnList[i].includeFreeVideo) {
              activeName.value = i
              collChange(i, true, 1);
              return false;
            }
          }
        } else {
          collChange(0, true);
        }
      }
      // 用户有播放记录，直接播放对应记录视频
      else {
        courseData.value.columnList.forEach((item, i) => {
          if (courseData.value.lastColumnId == item.onlineColumnId) {
            collChange(i, true);
            activeName.value = i;
          }
        });
      }
    }
  });
};

/************** 选修课相关 **************8*/
const takeColumnData = ref(""); // 选修课栏目数据
const takeName = ref(""); // 选修课栏目折叠面板数据
// 获取选修课列表
const AsyncListColumnOptionalCourse = () => {
  const params = {
    signUpUserId: signUpUserId.value,
    onlineClassId: onlineClassId.value,
  };
  courseApi.listColumnOptionalCourse(params).then((res) => {
    if (res.resCode == 200) {
      takeColumnData.value = res.resData;
    }
  });
};

// 切换选修课章节
const takeCollChange = (val, bol) => {
  activeName.value = "";
  if (takeColumnData.value.columnList[val] != undefined) {
    const params = {
      signUpUserId: signUpUserId.value,
      onlineClassId: takeColumnData.value.columnList[val].onlineClassId,
      onlineColumnId: takeColumnData.value.columnList[val].onlineColumnId,
    };
    if (bol == true) {
      AsynclistDataArticleOptionalCourse(params, true);
    } else {
      AsynclistDataArticleOptionalCourse(params, false);
    }
  }
};

// 获取选修课章节下的视频
const takeArticleList = ref({}); // 当前章节视频数据
const takeVideoEndIndex = ref(0); // 当前章节最后一个视频下标
const takeVideoIndex = ref(0); // 当前视频下标
const AsynclistDataArticleOptionalCourse = (params, bol) => {
  courseApi.listDataArticleOptionalCourse(params).then((res) => {
    if (res.resData.dataArticleList.length == 0) {
      takeArticleList.value = [];
    } else {
      takeArticleList.value = res.resData.dataArticleList;
      takeVideoEndIndex.value = takeArticleList.value.length;
      videoEndIndex.value = takeArticleList.value.length;

      takeArticleList.value.forEach((item) => {
        item.online_date_type = 1;
      });

      if (bol == true) {
        if (res.resData.lastColumnId == null) {
          changeVideo(
            takeArticleList.value[0],
            false,
            takeArticleList.value,
            0
          );
        } else {
          takeArticleList.value.forEach((item, i) => {
            if (item.articleId == res.resData.lastVideoId) {
              changeVideo(
                takeArticleList.value[i],
                false,
                takeArticleList.value,
                i
              );
            }
          });
        }
      }
      takeArticleList.value.forEach((item, i) => {
        if (
          currentVideoData.value.articleCcVideoPlayUrl ==
          item.articleCcVideoPlayUrl
        ) {
          item.conduct = true;
        } else {
          item.conduct = false;
        }
        nextTick(() => { });
      });
    }
  });
};

// 跳转表单
const go_form = () => {
  let userId = store.state.userInfo.userid;
  let formUrl = formData.value.formUrl + `&userId=${userId}`;
  window.open(formUrl);
};

// 获取章节下的视频数据
const dataArticleList = ref({}); // 当前章节视频数据
const videoEndIndex = ref(0); // 当前章节最后一个视频下标
const videoIndex = ref(0); // 当前视频下标
const AsyncListDataArticle = (params, bol, freeType) => {
  console.log(params);
  courseApi.listDataArticle(params).then((res) => {
    if (res.resData.dataArticleList.length == 0) {
      dataArticleList.value = [];
      console.log('没有视频');
      if (courseData.value.course.yxbType == 8 && !courseData.value.enrollStatus) {
        buyDialogVisible.value = true
        videoDisabled.value = false
        setTimeout(() => {
          player.value.pause();

        }, 2000)
      }
    } else {
      dataArticleList.value = res.resData.dataArticleList;
      videoEndIndex.value = dataArticleList.value.length;
      dataArticleList.value.forEach((item) => {
        item.online_date_type = 1;
      });
      if (bol == true) {
        if (!res.resData.lastColumnId) {
          if (
            courseData.value.course.yxbType === 8 &&
            !courseData.value.enrollStatus
          ) {
            if (dataArticleList.value[0].isFree) {

            }
            console.log(freeType);
            // 判断是否为进入课程后筛选第一个试看课程
            if (freeType) {
              for (let i = 0; i < dataArticleList.value.length; i++) {
                if (dataArticleList.value[i].isFree) {
                  changeVideo(
                    dataArticleList.value[i],
                    false,
                    dataArticleList.value,
                    i
                  );
                  return false;
                }
              }
            } else {

              if (dataArticleList.value[0].isFree) {
                changeVideo(
                  dataArticleList.value[0],
                  false,
                  dataArticleList.value,
                  0
                );
                return false;
              }

            }

          } else {
            changeVideo(
              dataArticleList.value[0],
              false,
              dataArticleList.value,
              0
            );
          }
        } else {
          dataArticleList.value.forEach((item, i) => {
            if (item.articleId == res.resData.lastVideoId) {
              changeVideo(
                dataArticleList.value[i],
                false,
                dataArticleList.value,
                i
              );
            }
          });
        }
      }
      dataArticleList.value.forEach((item, i) => {
        if (
          currentVideoData.value.articleCcVideoPlayUrl ==
          item.articleCcVideoPlayUrl
        ) {
          item.conduct = true;
        } else {
          item.conduct = false;
        }
        nextTick(() => { });
      });
    }
  });
};

// 切换章节
const collChange = (val, bol, freeType) => {
  takeName.value = "";
  if (courseData.value.columnList[val] != undefined) {
    const params = {
      signUpUserId: signUpUserId.value,
      onlineClassId: courseData.value.columnList[val].onlineClassId,
      onlineColumnId: courseData.value.columnList[val].onlineColumnId,
    };
    if (bol == true) {
      AsyncListDataArticle(params, true, freeType);
    } else {
      AsyncListDataArticle(params, false, freeType);
    }
  }
};

const buyDialogVisible = ref(false);
// 获取视频相关信息
const asyncOnlineVideo = (params, data, bol, data_item, index) => {
  courseApi
    .onlineVideo(params)
    .then((res) => {
      if (res.resCode == 200) {
        dataArticle.value = res.resData.dataArticle;
        lecturer.value = res.resData.lecturer;
        questionList.value = res.resData.questionList;
        questionList.value.forEach((item) => {
          item.answerShow = true;
        });
        data.conduct = true;
        data_item.forEach((item) => {
          if (
            currentVideoData.value.articleCcVideoPlayUrl ==
            item.articleCcVideoPlayUrl
          ) {
            item.conduct = true;
          } else {
            item.conduct = false;
          }
        });
        videoIndex.value = index;
        courseType.value = 1;
        aplayer.value = false;
        videoState.value = 2;
        if (player.value.destroy != undefined) {
          player.value.destroy();
        }
        createPlayer(data.articleCcVideoPlayUrl.replace(/(^\s*)|(\s*$)/g, ""));
        setTimeout(() => {
          videoDisabled.value = false;
        }, 3000);
      }
    })
    .catch((e) => {
      if (e.resCode == 201) {
        buyDialogVisible.value = true;
        player.value.pause();
      }
      return false;
    });
};

// 切换视频
const changeVideo = (data, bol, data_item, index) => {
  monitorInterval.value = 0;
  clearInterval(spaceTimer.value);
  currentVideoData.value = data;
  currentVideoData.value.online_class_id = onlineClassId.value;
  let anchorData = {
    signUpUserId: signUpUserId.value,
    onlineClassId: onlineClassId.value,
    onlineColumnId: data.onlineColumnId,
    onlineDataId: data.onlineDataId,
  };
  if (data.isOptionalVideo == 1) {
    anchorData.isOptionalCourse = 1;
  } else {
    anchorData.isOptionalCourse = 0;
  }
  asyncOnlineVideo(anchorData, data, bol, data_item, index);
};

// 获取视频进度
const AsyncListProcess = () => {
  const params = {
    signUpUserId: signUpUserId.value,
    onlineClassId: onlineClassId.value,
  };
  courseApi.listProcess(params).then((res) => {
    if (res.resCode == 200) {
      console.log('获取视频进度');
      console.log(res.resData.dataAnchorPopupType);
      if (res.resData.dataAnchorPopupType == 3) {
        classTestType.value = res.resData.dataAnchorPopupType;
      } else {
        if (res.resData.closeAnchorStatus == 1) {
          classTestType.value = 1;
        } else {
          classTestType.value = 3;
        }
      }

      proData.value = res.resData;
      // 判断用户是否学习完成
      // 课程已学习完成
      if (proData.value.examStatus == 1) {
        proData.value.totalPlayTime = proData.value.totalTime;
        learnFinish.value = true;
        // 限定不再调取去考试弹窗
        noCallPop.value = true;
      }
      // 课程已学习完成
      else if (proData.value.totalPlayTime >= proData.value.totalTime) {
        proData.value.totalPlayTime = proData.value.totalTime;
        learnFinish.value = true;
        // 限定不再调取去考试弹窗
        noCallPop.value = true;
      }
      // 课程未学习完成
      else {
        learnFinish.value = false;
        noCallPop.value = false;
      }
      // 视频学习进度
      Duration.value = res.resData.studyTotalPercent;
      // 锚点回答进度
      if (proData.value.totalQuestionCount == 0) {
        pro_answer.value = 100;
      } else {
        pro_answer.value = Number(
          Math.floor(
            (proData.value.totalFinishQuestionCount /
              proData.value.totalQuestionCount) *
            100
          )
        );
      }
    }
  });
};

// 视频播放相关功能
const isPicture = ref(false);
const maskBol = ref(false);
const drawShow = ref(false);
const monitorInterval = ref(0); // 监听视频时间间隔
const spaceTimer = ref(null); // 视频监听定时器
const currentVideoData = ref({}); // 当前视频相关数据
const dataArticle = ref({}); // 视频信息
const lecturer = ref({}); // 讲师信息
const questionList = ref({}); // 锚点信息
const courseType = ref(1);
const aplayer = ref(false);
const videoState = ref(2);
const ccVideo = ref(null);
const player = ref({});
const firstOn = ref(true);
const videoPlayerType = ref(1);
const noCallPop = ref(false); // 是否调用去考试弹窗 true:可以调用  false:不会调用
const learnFinish = ref(false); // 用户是否完成学习
const proData = ref({}); // 课程进度相关数据
const go_exam_show = ref(false);
const Duration = ref(0); // 总学习进度
const pro_answer = ref(0); // 锚点总进度
const maskType = ref(0); // 遮罩是否显示
// 操作视频播放暂停
const handleVideo = () => {
  if (videoState.value == 1) {
    player.value.pause();
  } else {
    player.value.play();
  }
};
// 切换至上一个视频
const lastVideo = () => {
  if (!videoDisabled.value) {
    if (currentVideoData.value.isOptionalVideo == 1) {
      activeName.value = "";
      if (videoIndex.value == 0) {
        if (takeName.value == 0) {
          ElMessage.warning("当前已经是第一个内容");
        } else {
          takeCollChange(takeName.value - 1, true);
          takeName.value -= 1;
          setTimeout(() => {
            if (takeArticleList.value.length == 0) {
              if (courseData.value.course.yxbType == 8 && !courseData.value.enrollStatus) {
                // buyDialogVisible.value = true
                // videoDisabled.value = false

                // player.value.pause();
              } else {
                ElMessage.warning("该章节下无课程");

              }
            } else {
              videoIndex.value = videoEndIndex.value - 1;

              changeVideo(
                takeArticleList.value[videoIndex.value],
                true,
                takeArticleList.value,
                videoIndex.value
              );
            }
          }, 1000);
        }
      } else {
        videoIndex.value -= 1;
        changeVideo(
          takeArticleList.value[videoIndex.value],
          true,
          takeArticleList.value,
          videoIndex.value
        );
      }
    } else {
      // if (
      //   courseData.value.course.yxbType == 8 &&
      //   !courseData.value.enrollStatus
      // ) {
      // } else {
      //   AsyncListColumn();
      // }
      takeName.value = "";
      setTimeout(() => {
        videoIndex.value == undefined
          ? (videoIndex.value = 0)
          : videoIndex.value;
        if (videoIndex.value == 0) {
          if (activeName.value == 0) {
            ElMessage.warning("当前已经是第一个内容");
          } else {
            collChange(activeName.value - 1, true);
            activeName.value--;
            setTimeout(() => {
              if (dataArticleList.value.length == 0) {
                if (courseData.value.course.yxbType == 8 && !courseData.value.enrollStatus) {
                  //   buyDialogVisible.value = true
                  //   videoDisabled.value = false
                  // player.value.pause();

                } else {
                  ElMessage.warning("该章节下无课程");

                }


              } else {
                videoIndex.value = videoEndIndex.value - 1;
                changeVideo(
                  dataArticleList.value[videoIndex.value],
                  true,
                  dataArticleList.value,
                  videoIndex.value
                );
              }
            }, 1000);
          }
        } else {
          videoIndex.value -= 1;
          changeVideo(
            dataArticleList.value[videoIndex.value],
            true,
            dataArticleList.value,
            videoIndex.value
          );
        }
      }, 200);
    }
  }
  videoDisabled.value = true;
};
// 切换至下一个视频
const nextVideo = () => {
  if (!videoDisabled.value) {
    if (currentVideoData.value.isOptionalVideo == 1) {
      activeName.value = "";
      maskType.value = 0;
      setTimeout(() => {
        videoIndex.value == undefined
          ? (videoIndex.value = 0)
          : videoIndex.value;
        if (videoIndex.value >= videoEndIndex.value - 1) {
          if (takeName.value >= takeColumnData.value.columnList.length - 1) {
            videoPlayerType.value = 0;
            ElMessage.warning("当前已经是最后一个内容");
            if (courseData.value.course.yxbType == 8 && !courseData.value.enrollStatus) {
              buyDialogVisible.value = true
              videoDisabled.value = false

              player.value.pause();
            }
          } else {
            videoPlayerType.value = 1;
            takeCollChange(takeName.value + 1, true);
            takeName.value++;
            videoIndex.value = 0;
            setTimeout(() => {
              if (takeArticleList.value.length == 0) {

                if (courseData.value.course.yxbType == 8 && !courseData.value.enrollStatus) {
                  // buyDialogVisible.value = true
                  // videoDisabled.value = false

                  // player.value.pause();
                } else {
                  ElMessage.warning("该章节下无课程");
                }

              } else {
                changeVideo(
                  takeArticleList.value[videoIndex.value],
                  true,
                  takeArticleList.value,
                  videoIndex.value
                );
              }
            }, 2000);
          }
        } else {
          videoIndex.value += 1;
          changeVideo(
            takeArticleList.value[videoIndex.value],
            true,
            takeArticleList.value,
            videoIndex.value
          );
        }
      }, 200);
    } else {
      takeName.value = "";
      maskType.value = 0;
      setTimeout(() => {
        videoIndex.value == undefined
          ? (videoIndex.value = 0)
          : videoIndex.value;
        if (videoIndex.value >= videoEndIndex.value - 1) {
          if (activeName.value >= courseData.value.columnList.length - 1) {
            videoPlayerType.value = 0;
            ElMessage.warning("当前已经是最后一个内容");
            if (courseData.value.course.yxbType == 8 && !courseData.value.enrollStatus) {
              buyDialogVisible.value = true
              videoDisabled.value = false

              player.value.pause();
            }
          } else {
            videoPlayerType.value = 1;
            videoIndex.value = 0;
            collChange(activeName.value + 1, true);
            activeName.value++;
            setTimeout(() => {
              if (dataArticleList.value.length == 0) {
                if (courseData.value.course.yxbType == 8 && !courseData.value.enrollStatus) {
                  // buyDialogVisible.value = true
                  // videoDisabled.value = false

                  // player.value.pause();
                } else {
                  ElMessage.warning("该章节下无课程");

                }


              } else {
                if (courseData.value.course.yxbType == 8 && !courseData.value.enrollStatus) {
                  console.log(videoIndex.value, 'ds');
                  if (dataArticleList.value[videoIndex.value].isFree) {
                    videoIndex.value = 0;
                    changeVideo(
                      dataArticleList.value[videoIndex.value],
                      true,
                      dataArticleList.value,
                      videoIndex.value
                    );
                  } else {
                    {
                      buyDialogVisible.value = true;
                      player.value.pause();
                    }

                  }
                } else {
                  videoIndex.value = 0;
                  changeVideo(
                    dataArticleList.value[videoIndex.value],
                    true,
                    dataArticleList.value,
                    videoIndex.value
                  );
                }


              }
            }, 2000);
          }
        } else {
          videoIndex.value += 1;
          changeVideo(
            dataArticleList.value[videoIndex.value],
            true,
            dataArticleList.value,
            videoIndex.value
          );
        }
      }, 200);
    }
    videoDisabled.value = true;
  }
};

// 初始化视频播放器
const createPlayer = (videoId) => {
  ccVideo.value = document.getElementById("ccVideo");
  let rateChange = true;
  currentVideoData.value.playTime / currentVideoData.value.totalTime >= 1
    ? (rateChange = true)
    : (rateChange = false);
  if (window.createCCH5Player == undefined) {
    setTimeout(() => {
      player.value = window.createCCH5Player({
        vid: videoId,
        vc: store.state.userInfo.userid,
        siteid: "3C9EB18A11C4DDFC",
        autoStart: false,
        parentNode: ccVideo.value,
        isShowRightMenu: false,
        rate_allow_change: rateChange,
        open_barrage: false,
        rate: 1,
        isShowMoreBtn: false,
        showRateBtn: rateChange,
      });
      setTimeout(() => {
        if (firstOn.value == false) {
          if (videoPlayerType.value == 1) {
            player.value.play();
          }
        }
        firstOn.value = false;
      }, 2000);
    }, 2000);
  } else {
    player.value = window.createCCH5Player({
      vid: videoId,
      vc: store.state.userInfo.userid,
      siteid: "3C9EB18A11C4DDFC",
      autoStart: false,
      parentNode: ccVideo.value,
      isShowRightMenu: false,
      rate_allow_change: rateChange,
      open_barrage: false,
      rate: 1,
      isShowMoreBtn: false,
      showRateBtn: rateChange,
    });
    setTimeout(() => {
      if (firstOn.value == false) {
        if (videoPlayerType.value == 1) {
          player.value.play();
        }
      }
      firstOn.value = false;
    }, 2000);
  }
};

// 初始化视频监听
const videoPlayTime = ref(0);
const styleTimeTimer = ref(null);
const setPlayerCallBack = () => {
  window.on_CCH5player_play = on_CCH5player_play;
  window.on_CCH5player_pause = on_CCH5player_pause;
  window.on_CCH5player_ended = on_CCH5player_ended;
  window.on_player_timeupdate = on_player_timeupdate;
};
const verifyImg = ref(""); // 人脸识别照片

// 视频播放时回调
const on_CCH5player_play = () => {
  maskType.value = 0;
  videoState.value = 1;
  if (!currentVideoData.value.isOptionalVideo) {
    const monitorParams = {
      signUpUserId: signUpUserId.value,
      onlineClassId: onlineClassId.value,
      onlineColumnId: currentVideoData.value.onlineColumnId,
      videoId: currentVideoData.value.articleId,
      videoPlayTime: videoPlayTime.value,
      monitorInterval: monitorInterval.value,
    };
    monitorProcess(monitorParams);
    monitorInterval.value = 0;
    clearInterval(spaceTimer.value);
    spaceTimer.value = window.setInterval(() => {
      monitorInterval.value += 1;
    }, 1000);
    clearInterval(styleTimeTimer.value);
    styleTimeTimer.value = window.setInterval(() => {
      const monitorParams = {
        signUpUserId: signUpUserId.value,
        onlineClassId: onlineClassId.value,
        onlineColumnId: currentVideoData.value.onlineColumnId,
        videoId: currentVideoData.value.articleId,
        videoPlayTime: videoPlayTime.value,
        monitorInterval: monitorInterval.value,
      };
      monitorProcess(monitorParams);
      monitorInterval.value = 0;
    }, 10000);
  } else {
    clearInterval(styleTimeTimer.value);
    // 判断是否需要进行人脸验证
    if (isEnableFaceValidateInLearning.value == 1) {
      // 当人脸识别锚点的第一个值为0时需要进行人脸验证
      if (faceValidatePosition.value[0]) {
        if (faceValidatePosition.value[0] == 0) {
          videoState.value = 1;
          faceState.value = 1;
          handleVideo();
          const params = {
            studentId: signUpUserId.value,
          };
          courseApi.getStudentInfo(params).then((res) => {
            if (res.resCode == 200) {
              verifyImg.value = res.resData.img;
              faceImageVisible.value = true;
            }
          });
          return;
        } else {
          if (res.resData.studyTotalTime >= faceValidatePosition.value[0]) {
            faceFailedVisible.value = true;
            videoState.value = 1;
            faceState.value = 1;
            handleVideo();
          }
        }
      } else {
        videoState.value = 1;
        faceState.value = 1;
        handleVideo();
      }
    }
  }
};

// 视频暂停回调
const on_CCH5player_pause = () => {
  videoState.value = 2;
  if (!currentVideoData.value.isOptionalVideo) {
    const monitorParams = {
      signUpUserId: signUpUserId.value,
      onlineClassId: onlineClassId.value,
      onlineColumnId: currentVideoData.value.onlineColumnId,
      videoId: currentVideoData.value.articleId,
      videoPlayTime: videoPlayTime.value,
      monitorInterval: monitorInterval.value,
    };
    monitorProcess(monitorParams);
    clearInterval(spaceTimer.value);
    clearInterval(styleTimeTimer.value);
    spaceTimer.value = null;
    styleTimeTimer.value = null;
    monitorInterval.value = 0;
  }
};

// 视频结束回调
const on_CCH5player_ended = () => {
  videoState.value = 2;
  if (!currentVideoData.value.isOptionalVideo) {
    const monitorParams = {
      signUpUserId: signUpUserId.value,
      onlineClassId: onlineClassId.value,
      onlineColumnId: currentVideoData.value.onlineColumnId,
      videoId: currentVideoData.value.articleId,
      videoPlayTime: videoPlayTime.value,
      monitorInterval: monitorInterval.value,
    };
    monitorProcess(monitorParams);
    clearInterval(spaceTimer.value);
    clearInterval(styleTimeTimer.value);
    spaceTimer.value = null;
    styleTimeTimer.value = null;
    monitorInterval.value = 0;
    if (
      courseData.value.isAutomaticPlayVideo == 1 &&
      courseData.value.chooseAutomaticPlayVideo == 1
    ) {
      nextVideo();
      setTimeout(() => {
        if (videoPlayerType.value == 1) {
          player.value.play();
        }
      }, 2000);
    } else {
      maskType.value = 1;
    }
  } else {
    clearInterval(spaceTimer.value);
    clearInterval(styleTimeTimer.value);
    spaceTimer.value = null;
    styleTimeTimer.value = null;
    monitorInterval.value = 0;
    if (
      courseData.value.isAutomaticPlayVideo == 1 &&
      courseData.value.chooseAutomaticPlayVideo == 1
    ) {
      nextVideo();
      setTimeout(() => {
        if (videoPlayerType.value == 1) {
          player.value.play();
        }
      }, 2000);
    } else {
      maskType.value = 1;
    }
  }
};

const testShow = ref(false);
const anchor_list = ref({});
// 视频播放时间修改回调
const on_player_timeupdate = (time) => {
  videoPlayTime.value = time.toFixed(0);
  questionList.value.forEach((item) => {
    if (time.toFixed(0) == item.anchorPopupTime) {
      if (item.answerShow == true) {
        // 该锚点用户未回答
        if (item.isAnswer == 0) {
          if (classTestType.value != 3) {
            testShow.value = true;
            player.value.pause();
            anchor_list.value = item;
            anchor_list.value.anchorShow = false;
            player.value.normalScreen();
            item.answerShow = false;
            faceFailedVisible.value = false;
          }
        }
        // 该锚点用户已回答
        else {
          // 该锚点每次都弹出
          if (item.anchorStatus == 2) {
            if (classTestType.value != 3) {
              testShow.value = true;
              faceFailedVisible.value = false;
              player.value.pause();
              anchor_list.value = item;
              anchor_list.value.anchorShow = false;
              player.value.normalScreen();
              item.answerShow = false;
            }
          }
        }
      }
    }
  });
};

const faceState = ref(2);
// 是否显示多端学习弹窗提示
const isMultipleDialog = ref(false);

// 监听学习进度
const monitorProcess = (params) => {
  // 显示了多端学习弹窗提示就不再调进度接口
  if (isMultipleDialog.value) return;
  if (courseData.value.course.yxbType == 8 && !courseData.value.enrollStatus)
    return;
  courseApi.monitorProcess(params).then((res) => {
    if (res.resCode == 200) {
      currentVideoData.value.questionFinishCount =
        res.resData.questionFinishCount;
      faceValidatePosition.value = res.resData.faceValidatePosition;
      if (res.resData.isPlayFinish == 1) {
        currentVideoData.value.playTime = res.resData.articleVideoTime;
      } else {
        currentVideoData.value.playTime = res.resData.playTime;
      }
      currentVideoData.value.valuetotalTime = res.resData.articleVideoTime;

      // 判断是否需要进行人脸验证
      if (isEnableFaceValidateInLearning.value == 1) {
        // 当人脸识别锚点的第一个值为0时需要进行人脸验证
        if (faceValidatePosition.value) {
          if (faceValidatePosition.value[0] == 0) {
            videoState.value = 1;
            faceState.value = 1;
            handleVideo();
            const params = {
              studentId: signUpUserId.value,
            };
            courseApi.getStudentInfo(params).then((res) => {
              if (res.resCode == 200) {
                verifyImg.value = res.resData.img;
                faceImageVisible.value = true;
              }
            });
            return;
          } else {
            if (res.resData.studyTotalTime >= faceValidatePosition.value[0]) {
              faceFailedVisible.value = true;
              videoState.value = 1;
              faceState.value = 1;
              handleVideo();
            }
          }
        }
      }

      if (noCallPop.value == true) {
        if (res.resData.isClassFinish == 1) {
          learnFinish.value = true;
          proData.value.examStatus = 1;
        }
        // 课程未学习完成
        else {
          learnFinish.value = false;
        }
      } else {
        // 课程已学习完成
        if (res.resData.isClassFinish == 1) {
          AsyncListProcess();
          learnFinish.value = true;
          if (courseData.value.examCount > 0) {
            go_exam_show.value = true;
          }
          noCallPop.value = true;
        }
        // 课程未学习完成
        else {
          learnFinish.value = false;
        }
      }

      // 判断当前章节是否学完
      courseData.value.columnList.forEach((item) => {
        if (item.onlineColumnId == res.resData.onlineColumnId) {
          item.finishedStatus = res.resData.finishedStatus;
        }
      });

      // 视频学习进度
      proData.value.totalPlayTime = res.resData.studyTotalTime;
      if (proData.value.totalPlayTime >= proData.value.totalTime) {
        proData.value.totalPlayTime = proData.value.totalTime;
        Duration.value = res.resData.studyTotalPercent;
      } else {
        Duration.value = res.resData.studyTotalPercent;
      }

      // 锚点回答进度
      if (proData.value.totalQuestionCount == 0) {
        pro_answer.value = 100;
      } else {
        pro_answer.value = Number(
          Math.floor(
            (proData.value.totalFinishQuestionCount /
              proData.value.totalQuestionCount) *
            100
          )
        );
      }
    } else if (res.resCode == 999) {
      isMultipleDialog.value = true;
      handleVideo();
      // 视频补课的多端学习
      ElMessageBox.confirm(res.resMessage, "提示", {
        confirmButtonText: "确认",
        showCancelButton: false,
        showClose: false,
        type: "warning",
      }).then(() => {
        isMultipleDialog.value = false;
        window.location.href = "/#/";
      });
    }
  });
};

// 手动修改随堂小考开启状态
const ChangeTesting = (val) => {
  val == 1 ? (classTestType.value = val) : (classTestType.value = 3);
  const params = {
    signUpUserId: signUpUserId.value,
    closeAnchorStatus: val,
    courseId: courseId.value,
  };
  courseApi.updateUserAnchorStatus(params).then((res) => {
    ElMessage.success("随堂小考是否显示状态修改成功");
  }).catch(e => {
    classTestType.value = 1
    proData.value.closeAnchorStatus = 1
  });
};

// 修改自动续播状态
const ChangeVideoSnap = (val) => {
  const params = {
    studentId: signUpUserId.value,
    chooseAutomaticPlayVideo: val,
  };
  courseApi.updateChooseAutomaticPlayVideo(params).then((res) => {
    ElMessage.success("视频自动续播状态修改成功");
  }).catch(e => {
    if (e.resCode == 201) {
      ElMessage.error(e.resMessage);

    }
    courseData.value.chooseAutomaticPlayVideo = 1
  });
};

const handleScroll = () => {
  var scrollTop =
    window.pageYOffset ||
    document.documentElement.scrollTop ||
    document.body.scrollTop;
  if (scrollTop > 580) {
    isPicture.value = true;
    drawShow.value = true;
  } else {
    isPicture.value = false;
    drawShow.value = false;
  }
};
const video_container = ref(null);
const drawleft = ref(0);
const drawtop = ref(0);
watch(drawShow, (val) => {
  if (val) {
    if (drawleft.value == 0 && drawtop.value == 0) {
      video_container.value.style.right = 60 + "px";
      video_container.value.style.bottom = 100 + "px";
      video_container.value.style.left = "auto";
      video_container.value.style.top = "auto";
    } else {
      video_container.value.style.left = drawleft.value + "px";
      video_container.value.style.top = drawtop.value + "px";
      video_container.value.style.right = "auto";
      video_container.value.style.bottom = "auto";
    }
  } else {
    video_container.value.style.left = 0;
    video_container.value.style.top = 0;
  }
});

// 资料下载
const goDownload = () => {
  window.open(courseData.value.batchDownloadMaterialUrl);
};

/**
 * @description: C端研修班报名
 * @return {*}
 */
const enroll = () => {
  const params = {
    courseId: route.query.courseId,
  };
  courseApi.enrollPartialFreeCourse(params).then((res) => {
    router.push({
      path: "/order/confirm",
      query: {
        orderId: res.resData.orderId,
      },
    });
  });
};

const homePage = ref(null);
// 动态修改样式
const changeFixed = (clientHeight) => {
  //动态修改样式
  homePage.value.style.height = clientHeight + "px";
};

const clientHeight = ref(0);
watch(clientHeight, (val) => {
  if (val >= 850) {
    changeFixed(clientHeight.value);
  } else {
    changeFixed(850);
  }
});

const vDrag = function (el) {
  let dragBox = el; //获取当前元素
  if (drawShow.value == true) {
    dragBox.onmousedown = (e) => {
      //算出鼠标相对元素的位置
      let disX = e.clientX - dragBox.offsetLeft;
      let disY = e.clientY - dragBox.offsetTop;
      document.onmousemove = (e) => {
        //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
        drawleft.value = e.clientX - disX;
        drawtop.value = e.clientY - disY;
        if (drawtop.value < 0) {
          drawtop.value = 0;
        }
        if (drawtop.value > document.documentElement.clientHeight - 236) {
          drawtop.value = document.documentElement.clientHeight - 236;
        }
        if (drawleft.value < 0) {
          drawleft.value = 0;
        }
        if (drawleft.value > document.documentElement.clientWidth - 320) {
          drawleft.value = document.documentElement.clientWidth - 320;
        }
        //移动当前元素
        dragBox.style.left = drawleft.value + "px";
        dragBox.style.top = drawtop.value + "px";
      };
      document.onmouseup = () => {
        //鼠标弹起来的时候不再移动
        document.onmousemove = null;
        //预防鼠标弹起来后还会循环（即预防鼠标放上去的时候还会移动）
        document.onmouseup = null;
      };
    };
  } else {
    dragBox.onmousedown = () => {
      document.onmousemove = () => {
        //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
      };
      document.onmouseup = () => {
        //鼠标弹起来的时候不再移动
        document.onmousemove = null;
        //预防鼠标弹起来后还会循环（即预防鼠标放上去的时候还会移动）
        document.onmouseup = null;
      };
    };
    return false;
  }
};

// 获取表单相关信息
const formData = ref({
  formTitle: "",
});
const formInfoData = ref({});
const AsyncGetCourseFormInformation = () => {
  const params = {
    courseId: courseId.value,
    studentId: signUpUserId.value,
  };
  courseApi.getCourseFormInformation(params).then((res) => {
    if (res.resCode == 200) {
      formData.value = res.resData;
      const userInfo = store.state.userInfo;
      if (formData.value.isOpenForm == 1 && formData.value.formId != "") {
        let formParams = qs.parse({
          userId: userInfo.userid,
          formId: formData.value.formId,
        });
        let config = {
          headers: { "Content-Type": "application/json; charset=utf-8" },
        };
        axios
          .post(
            process.env.VUE_APP_FORM_URL + "/front/survey/loadUserIsSubmit",
            formParams,
            config
          )
          .then((res) => {
            if (res.data.status == 200) {
              formInfoData.value = res.data.data;
            }
          })
          .catch((e) => {
            return e;
            Elmessage.success(e);
          });
      }
    }
  });
};

const signTest = (val) => {
  testShow.value = false;
  player.value.play();
  if (val == 0) {
    currentVideoData.value.questionFinishCount++;
    proData.value.totalFinishQuestionCount++;
    currentVideoData.value.questionFinishCount++;
  }
};

// 获取课程通知
const noticeShow = ref(false);
const noticeData = ref("");
const AsyncGetYktMessage = () => {
  const params = {
    courseId: courseId.value,
  };
  homeApi.getYktMessage(params).then((res) => {
    if (res.resData) {
      noticeShow.value = true;
      noticeData.value = res.resData;
    }
  });
};

const videoTimer = ref(null);
const codeImg = ref("");

// 获取学习页面广告接口
const advertData = ref("");
const AsyncListStudyAdvert = () => {
  const params = {};
  homeApi.listStudyAdvert(params).then((res) => {
    advertData.value = res.resData;
  });
};

/**
 * 图片裁剪相关功能
 */
// 图片裁剪组件是否显示
let cropperModel = ref(false);
// 图片地址
let changeImg = ref("");
// 图片裁剪框比例
let fixedNumber = ref([1.5, 2]);
// 上传到接口的图片
let upDatePhotoImage = ref("");
// 图片回传
const confirmUpload = (data) => {
  verifyImg.value = window.URL.createObjectURL(data);
  upDatePhotoImage.value = data;
  cropperModel.value = false;
  UpdatePhoto();
};
// 自定义上传图片
const httpRequest = (e) => {
  let file = e.file;
  let imgType = file.type;
  if (imgType !== "image/jpeg" && imgType !== "image/png") {
    ElMessage({
      message: "请上传jpg、png格式的图片",
      type: "warning",
      customClass: "messageIndex",
    });
    return;
  }
  if (file.size / 1024 / 1024 > 5) {
    ElMessage({
      message: "请上传5MB以下的图片",
      type: "warning",
      customClass: "messageIndex",
    });
    return;
  }
  // 上传证件照
  let reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = (e) => {
    changeImg.value = e.target.result;
    cropperModel.value = true;
  };
};

// 修改学员照片
const UpdatePhoto = () => {
  const params = {
    studentId: signUpUserId.value,
    file: upDatePhotoImage.value,
  };
  courseApi.updateStudent(params).then((res) => {
    if (res.resCode == 200) {
      ElMessage({
        message: "图片修改成功",
        type: "success",
        customClass: "messageIndex",
      });
    }
  });
};

// 进行人脸识别
const GoFaceVerify = () => {
  const nonce = randomString(32);
  const params = {
    studentId: signUpUserId.value,
    courseId: courseId.value,
    positionNumber: faceValidatePosition.value[0],
    nonce: nonce,
  };

  courseApi.getStudyFaceId(params).then((res) => {
    const resData = res.resData;
    let appId = process.env.VUE_APP_FACE_ID;
    let userId = store.state.userInfo.userid;
    let obj = {
      userId,
      nonce,
      version: "1.0.0",
      h5faceId: resData.faceId,
      orderNo: resData.orderId,
    };
    // 将orderId 存入缓存
    sessionStorage.ExamOrderId = resData.orderId;

    // 签名
    let sign = sha1Sign({
      ...obj,
      wbappid: appId,
      ticket: resData.nonceTicket,
    });
    // 跳转链接
    let url = "https://miniprogram-kyc.tencentcloudapi.com/api/pc/login";
    let { origin, hash } = location;
    let source = "exam_verify";
    if (hash.indexOf("exam_main") !== -1) {
      source = "exam_main";
    }
    url =
      url +
      splitJointUrl({
        ...obj,
        webankAppId: appId,
        url: encodeURIComponent(
          `${origin}/?faceVerify=yes#/courseDetail?signUpUserId=${signUpUserId.value}&onlineClassId=${onlineClassId.value}&courseId=${courseId.value}&orderId=${resData.orderId}`
        ),
        sign,
      });
    location.replace(url);
  });
};

/**
 * @description: 退出学习页面
 * @return {*}
 */
const ExitStudy = () => {
  router.push({
    path: "/course",
  });
};

const AsyncVerifyStudyFaceResult = () => {
  const orderId = localStorage.getItem("orderNo");
  const params = {
    studentId: signUpUserId.value,
    orderId: orderId,
    positionNumber: faceValidatePosition.value[0],
  };
  localStorage.removeItem("orderNo");
  courseApi.verifyStudyFaceResult(params).then((res) => {
    router.push(
      {
        path: "/courseDetail",
        query: {
          signUpUserId: signUpUserId.value,
          onlineClassId: onlineClassId.value,
          courseId: courseId.value,
        },
      },
      () => {
        that.reload(); //刷新页面
      }
    );
  });
};

const ebookShow = ref(false);
const ebookImgType = ref(0);
onMounted(() => {
  codeImg.value = require(process.env.VUE_APP_CODE_IMG);

  setPlayerCallBack();
  signUpUserId.value = route.query.signUpUserId;
  onlineClassId.value = route.query.onlineClassId;
  courseId.value = route.query.courseId;
  if (
    ["1595", "1592", "1588", "1580", "1579", "1578", "1132"].includes(
      courseId.value
    )
  ) {
    ebookImgType.value = 1;
    ebookShow.value = true;
  } else if (
    ["1610", "1609", "1608", "1607", "1606", "1605", "1596"].includes(
      courseId.value
    )
  ) {
    ebookImgType.value = 2;
    ebookShow.value = true;
  }
  // 当网址中有code参数时进行对应操作
  if (getQueryStr("code")) {
    // 当code为0时人脸识别通过，将不需要的数据清除，删除缓存中的faceCode数据，之后重新加载该页面
    if (getQueryStr("code") == 0) {
      localStorage.removeItem("faceCode");
      localStorage.setItem("orderNo", getQueryStr("orderNo"));
    } else {
      localStorage.setItem("faceCode", 1);
    }
    window.location.href = `${process.env.VUE_APP_FACE_URL}/#/courseDetail?signUpUserId=${route.query.signUpUserId}&onlineClassId=${route.query.onlineClassId}&courseId=${route.query.courseId}`;
  }

  AsyncListColumn();
  AsyncGetCourseFormInformation();
  AsyncGetYktMessage();
  AsyncListStudyAdvert();

  // 浏览器滚动事件
  window.addEventListener("scroll", handleScroll);

  window.onkeydown =
    window.onkeyup =
    window.onkeypress =
    function (event) {
      if (event.keyCode == 32) {
        window.event.returnValue = false;
        event.preventDefault(); // 阻止默认事件行为
        window.event.returnValue = false;
      }
    };
  // 监听 video元素 是否含有 controls 属性
  videoTimer.value = setInterval(() => {
    let video = document.querySelector("video");
    if (video && video.getAttribute("controls") !== null) {
      video.remove();
    }
  }, 5000);
});

onUnmounted(() => {
  clearInterval(styleTimeTimer.value);
  if (player.value.destroy != undefined) {
    player.value.destroy();
  }
  document.removeEventListener("scroll", handleScroll);
  clearInterval(videoTimer.value);
});
</script>

<style lang="scss">
.el-collapse-item__content {
  padding: 0 !important;
}

.el-loading-spinner {
  display: fixed !important;
  top: 300px !important;
}

.detail_wrap {
  .pic_virify {
    .pic_wrap {
      display: inline-block;
      width: 116px;
      vertical-align: top;
      margin-right: 34px;

      .upload {
        width: 100%;
        height: 170px;
      }

      .require {
        margin-top: 6px;

        span {
          display: inline-block;
          vertical-align: middle;
        }

        i {
          margin-left: 4px;
          vertical-align: middle;
        }
      }

      .pic {
        width: 116px;
        height: 170px;
        border: 1px solid #dbdbdb;
        cursor: pointer;
        text-align: center;

        .upload-wrap {
          text-align: center;
          width: 100%;
          height: 100%;
          position: relative;

          &:hover {
            .upload_pic {
              display: block;
            }
          }

          .verify_img {
            width: 116px;
            height: 170px;
          }

          .iconren111 {
            font-size: 100px;
            display: inline-block;
            margin-top: 30px;
          }

          .upload_pic {
            position: absolute;
            display: none;
            width: 100%;
            height: 100%;
            top: 0;
            background: rgba(0, 0, 0, 0.8);
            text-align: center;
            color: #ffffff;

            i {
              font-size: 96px;
              font-weight: 900;
              margin-top: 20px;
            }

            p {
              font-size: 16px;
              margin-top: 8px;
            }
          }
        }

        .reupload {
          display: inline-block;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #0088e8;
          cursor: pointer;
          border-bottom: 1px solid #0088e8;
          margin: 6px 0;
        }
      }
    }

    .pic_tip {
      display: inline-block;
      width: 440px;
      vertical-align: top;

      p {
        font-size: 14px;
        line-height: 30px;
      }
    }
  }

  .go_exam_mask {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99999;

    .go_exam_guanbi {
      position: absolute;
      bottom: -80px;
      font-size: 40px !important;
      left: 50%;
      margin-left: -20px;
      color: #ffffff;
      cursor: pointer;
      transition: all 0.25s;
    }

    .exam_img {
      width: 280px;
      position: absolute;
      top: 200px;
      left: 0;
      right: 0;
      margin: auto;

      .btn_wrap {
        position: absolute;
        top: 70%;
        text-align: center;
        width: 100%;
      }

      img {
        width: 100%;
        height: auto;
      }
    }
  }

  width: 1024px;
  margin: 0 auto;

  #course_wrap {
    width: 1024px;
    margin: 0 auto;
    min-height: calc(100vh - 156px);

    .course_header {
      .course_title {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;
        width: 600px;
        display: inline-block;
        font-size: 24px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 44px;
        letter-spacing: 2px;
        color: #7a818b;
        margin: 24px 0 14px 0;
        cursor: pointer;
      }

      .phone_btn {
        float: right;
        margin-top: 24px;

        .xcx_img {
          width: 160px;
          display: block;
        }
      }
    }

    .course_left {
      display: inline-block;
      width: 750px;
      position: relative;

      .video_center {
        position: relative;
        height: 516px;

        .perch {
          width: 750px;
          height: 422px;
        }

        .video_container {
          position: relative;

          .buy_tips {
            position: absolute;
            bottom: 86px;
            z-index: 999;
            background: #000000;
            border-radius: 9px;
            opacity: 0.84;
            font-weight: 400;
            font-size: 14px;
            color: #ffffff;
            line-height: 28px;
            padding: 0 16px;

            span {
              color: #50acff;
              display: inline-block;
              margin-left: 6px;
              cursor: pointer;
            }
          }

          .ccVideo {
            width: 100%;
            height: 100%;
            position: absolute;
            z-index: 1;
          }

          .video_mask {
            width: 100%;
            height: 100%;
            position: absolute;
            background: rgba(0, 0, 0, 0.8);
            z-index: 9999;

            .mask_btn_wrap {
              text-align: center;
              margin-top: 24%;
            }
          }

          .perch_drag {
            width: 100%;
            height: 100%;
            position: absolute;
            z-index: 2;
            text-align: center;
            display: none;
            align-items: center;
            justify-content: center;
            background: rgba(0, 0, 0, 0.6);
            cursor: move;

            i {
              display: inline-block;
              color: #ebebeb;
              font-size: 48px;
              cursor: pointer;
            }
          }

          &:hover {
            .perch_drag {
              display: flex;
            }
          }
        }

        .noPictureVideo {
          width: 750px;
          height: 422px;
          position: absolute;
          top: 0;
          background: #ffffff;
        }

        .pictureVideo {
          width: 320px;
          height: 180px;
          position: fixed;
          bottom: 100px;
          right: 40px;
          z-index: 999;
        }

        .el-alert__close-btn {
          right: 6px !important;
          color: #000000 !important;
        }

        .course_handle {
          width: 750px;
          background: #ffffff;

          .video_bo_btn {
            display: inline-block;
            margin: 0 20px;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 50px;
            letter-spacing: 0px;
            color: #7a818b;
            cursor: pointer;

            i {
              vertical-align: middle;
              font-size: 16px;
            }

            span {
              vertical-align: middle;
              margin-left: 2px;
            }
          }

          .auto_wrap {
            float: right;
            margin: 8px 8px;

            label {
              vertical-align: middle;
              margin-right: 4px;
              color: #7a818b;
            }
          }

          .free_wrap {
            float: right;
            margin: 9px 8px;

            label {
              vertical-align: middle;
              margin-right: 4px;
              color: #7a818b;
            }
          }

          .video_speed {
            float: right;
            margin: 5px 8px;
          }
        }
      }

      .video_info {
        margin-top: 24px;

        .video_list {
          width: 750px;
          display: inline-block;
          position: relative;
          background: #ffffff;

          .video_list_title {
            font-size: 16px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 16px;
            letter-spacing: 0px;
            color: #7a818b;
            margin: 24px 16px 20px 16px;
            padding-left: 10px;
            border-left: 2px solid #7a818b;
          }

          .form {
            cursor: pointer;

            .form_center {
              display: inline-block;
              width: 458px;

              i {
                margin-left: 34px;
                font-size: 18px;
                color: #7d848e;
                vertical-align: middle;
              }

              span {
                display: inline-block;
                line-height: 48px;
                width: 388px;
                vertical-align: middle;
                font-size: 14px;
                font-weight: normal;
                font-stretch: normal;
                letter-spacing: 1.4px;
                color: #7e858f;
                margin-left: 14px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }

            .form_state {
              width: 146px;
              text-align: center;
              display: inline-block;
            }
          }

          .zhangjie {
            margin-left: 34px;
            font-size: 18px;
            color: #7d848e;
          }

          .video_title {
            width: 450px;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 1.4px;
            color: #7e858f;
            margin-left: 14px;

            text-align: left;

            span {
              width: 340px;
              display: inline-block;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              vertical-align: middle
            }


          }

          .free_tag {
            display: inline-block;
            border-radius: 6px;
            border: 1px solid #f29c38;
            font-size: 14px;
            color: #f29c38;
            padding: 2px 3px;
            line-height: 14px;
          }

          .title_lone {
            width: 500px;
          }

          .video_state {
            width: 146px;
            text-align: center;
            display: inline-block;

            .el-progress__text {
              left: -6px !important;
            }
          }

          .learn {
            width: 130px;
          }

          .chapter_list {
            padding: 0;
            margin: 0;

            .patch {
              span {
                color: #418ec6;

                img {
                  height: 14px;
                  vertical-align: middle;
                }
              }

              i {
                color: #418ec6;
              }
            }

            .unchecked {
              span {
                color: #7a818b;
              }
            }

            li {
              border-top: 1px solid #f5f5f5;
              cursor: pointer;
              overflow: hidden;

              .list_wrap {
                display: inline-block;
                width: 458px;

                .chapter_title {
                  font-size: 14px;
                  font-weight: normal;
                  font-stretch: normal;
                  line-height: 46px;
                  letter-spacing: 1.4px;
                  margin-left: 66px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  min-width: 100px;
                  max-width: 340px;
                  padding-right: 10px;
                  display: inline-block;
                  vertical-align: middle;
                }

                .free_tag {
                  display: inline-block;
                  border-radius: 6px;
                  border: 1px solid #f29c38;
                  font-size: 14px;
                  color: #f29c38;
                  padding: 2px 3px;
                  line-height: 14px;
                }

                .lock {
                  color: #999999;
                }

                i {
                  font-weight: 900;
                  vertical-align: middle;
                }

                .video_state {
                  font-size: 14px;
                  font-weight: normal;
                  font-stretch: normal;
                  line-height: 46px;
                  letter-spacing: 1.3px;
                }

                .learn {
                  float: right;
                  line-height: 48px;
                }
              }

              .chapter_title_lone {
                width: 570px;
              }

              &:hover {
                span {
                  color: #418ec6;

                  img {
                    height: 14px;
                    vertical-align: middle;
                  }
                }

                i {
                  color: #418ec6 !important;
                }
              }
            }
          }
        }

        .survey_wrap {
          cursor: pointer;
          height: 50px;
          background: #ffffff;
          margin-top: 16px;
          font-size: 16px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 45px;
          letter-spacing: 2px;
          color: #7e858f;

          .form_title {
            margin-left: 36px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: 421px;

            i {
              margin-right: 10px;
            }
          }

          p {
            display: inline-block;
            vertical-align: middle;
          }

          .form_state {
            width: 146px;
            text-align: center;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 45px;
            letter-spacing: 1px;
          }
        }

        .take_list {
          width: 750px;
          display: inline-block;
          position: relative;
          background: #ffffff;
          margin-top: 10px;

          .take_list_title {
            font-size: 16px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 16px;
            letter-spacing: 0px;
            color: #7a818b;
            margin: 24px 16px 20px 16px;
            padding-left: 10px;
            border-left: 2px solid #7a818b;

            span {
              font-size: 16px;
              font-weight: normal;
              letter-spacing: 0px;
              color: #e03a3b;
            }
          }

          .zhangjie {
            margin-left: 34px;
            font-size: 18px;
            color: #7d848e;
          }

          .video_title {
            width: 450px;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 1.4px;
            color: #7e858f;
            margin-left: 14px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            text-align: left;

            .free_tag {
              display: inline-block;
              border-radius: 6px;
              border: 1px solid #f29c38;
              font-size: 14px;
              color: #f29c38;
              padding: 2px 3px;
              line-height: 14px;
            }
          }

          .title_lone {
            width: 500px;
          }

          .video_state {
            width: 146px;
            text-align: center;
            display: inline-block;
          }

          .learn {
            float: right;
            line-height: 48px;
          }

          .chapter_list {
            padding: 0;
            margin: 0;

            .patch {
              span {
                color: #418ec6;

                img {
                  height: 14px;
                  vertical-align: middle;
                }
              }

              i {
                color: #418ec6;
              }
            }

            .unchecked {
              span {
                color: #7a818b;
              }
            }

            li {
              border-top: 1px solid #f5f5f5;
              cursor: pointer;
              overflow: hidden;

              .list_wrap {
                display: inline-block;
                width: 458px;

                .chapter_title {
                  font-size: 14px;
                  font-weight: normal;
                  font-stretch: normal;
                  line-height: 46px;
                  letter-spacing: 1.4px;
                  margin-left: 66px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  min-width: 100px;
                  max-width: 340px;
                  padding-right: 10px;
                  display: inline-block;
                  vertical-align: middle;
                }

                i {
                  font-weight: 900;
                  vertical-align: middle;
                }

                .video_state {
                  font-size: 14px;
                  font-weight: normal;
                  font-stretch: normal;
                  line-height: 46px;
                  letter-spacing: 1.3px;
                }

                .learn {
                  float: right;
                  line-height: 48px;
                }
              }

              .chapter_title_lone {
                width: 570px;
              }
            }
          }
        }
      }
    }

    .course_right {
      float: right;
      width: 260px;
      vertical-align: top;

      // 文章类模块
      .articeHandle {
        width: 100%;
        background: #ffffff;
        overflow: hidden;

        .artice_title {
          font-size: 16px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 24px;
          letter-spacing: 0px;
          color: #7a818b;
          padding: 6px 12px;
        }

        .pro {
          margin: 12px;
          overflow: hidden;

          .el-progress-bar {
            padding: 0;
          }

          .el-progress__text {
            float: right;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 37px;
            letter-spacing: 0px;
            color: #ff9f0c;
          }
        }

        .handle_video {
          margin: 10px auto 18px auto;
          width: 100%;
          text-align: center;
          overflow: hidden;

          i {
            color: #7a818b;
            font-size: 24px;
            cursor: pointer;
          }

          .left {
            float: left;
            margin-left: 18px;
          }

          .right {
            float: right;
            margin-right: 18px;
          }
        }
      }

      // 音视频模块
      .course {
        width: 100%;
        background: #ffffff;
        overflow: hidden;

        .course_title {
          font-size: 18px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #7a818b;
          margin: 10px 16px;
          line-height: 24px;
          font-weight: 900;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          overflow: hidden;
        }

        .time {
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 1px;
          color: #aaaaaa;
          margin-left: 16px;
          margin-bottom: 20px;
        }
      }

      .lecturer_present {
        width: 100%;
        background: #ffffff;
        overflow: hidden;
        margin-top: 10px;

        .info {
          .pic {
            display: inline-block;
            margin: 0 15px 0 15px;
            width: 44px;
            height: 44px;
            border-radius: 50%;
            overflow: hidden;
            vertical-align: middle;

            img {
              width: 100%;
              height: 100%;
            }
          }

          .news {
            display: inline-block;
            vertical-align: middle;

            .name_wrap {
              .name {
                display: inline-block;
                font-size: 16px;
                font-weight: normal;
                font-stretch: normal;
                line-height: 33px;
                letter-spacing: 0px;
                color: #7a818b;
                vertical-align: middle;
              }

              .tip {
                display: inline-block;
                background-color: #ffba00;
                font-size: 12px;
                font-weight: normal;
                font-stretch: normal;
                letter-spacing: 0px;
                color: #ffffff;
                vertical-align: middle;
                padding: 2px 6px;
                margin-left: 10px;
                border-radius: 4px;
              }
            }
          }
        }
      }

      .handle {
        width: 100%;
        background: #ffffff;
        position: relative;
        overflow: hidden;

        .title {
          font-size: 16px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 24px;
          letter-spacing: 0px;
          color: #7a818b;
          padding: 10px;
        }

        .hand_txt {
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 26px;
          letter-spacing: 0px;
          color: #7a818b;
          padding: 0 10px;
        }

        .hand_data {
          margin: 20px 10px;
          overflow: hidden;

          span {
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #7a818b;
          }

          .topic {
            float: left;
          }

          .rate_learn {
            float: right;
          }
        }

        .handle_video {
          margin: 10px auto 20px auto;
          width: 100%;
          text-align: center;

          i {
            color: #7a818b;
            font-size: 24px;
            cursor: pointer;
          }

          .left {
            float: left;
            margin-left: 20px;
          }

          .right {
            float: right;
            margin-right: 20px;
          }
        }
      }

      .my_exam {
        width: 100%;
        background: #ffffff;
        margin-top: 10px;
        overflow: hidden;

        .exam_title {
          width: 234px;
          margin: 0 auto;
          border-bottom: 1px solid #f5f5f5;

          .notice {
            float: right;
            margin-top: 18px;
            font-size: 14px;
            color: #418ec6;
            cursor: pointer;

            &:hover {
              color: #ffba00;
              border-bottom: 1px solid #ffba00;
            }
          }

          .my_exam_txt {
            font-size: 18px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #7a818b;
            margin: 16px 0;
            padding-left: 10px;
            border-left: 4px solid #7a818b;
            display: inline-block;
          }

          .el-link {
            float: right;
            margin-top: 17px;
          }
        }

        .go_exam {
          text-align: center;
          margin: 30px 0;

          .exam_tip {
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 30px;
            letter-spacing: 0px;
            color: #7a818b;

            .exam_tip_big {
              display: block;
              text-align: center;
            }

            .two {
              text-align: center;
              font-size: 18px;
            }

            .exam_tip_little {
              font-size: 14px;
              display: block;
              text-align: center;
              color: #df3031;
            }
          }

          .go_exam_list {
            .error {
              width: 68px;
              height: auto;
              vertical-align: middle;
            }

            .make_up_handle {
              display: inline-block;
              vertical-align: middle;
              margin-left: 16px;

              p {
                font-size: 14px;
                font-weight: normal;
                font-stretch: normal;
                margin-bottom: 8px;
                letter-spacing: 0px;
                color: #418ec6;
                cursor: pointer;
              }

              .go_score {
                &:hover {
                  color: #ffba00;
                  border-bottom: 1px solid #ffba00;
                }
              }

              .el-button {
                padding: 6px 20px;
                background: #5c90bf;
              }
            }
          }

          .adopt {
            .exam_number {
              color: #ffba00;
            }
          }

          .error {
            p {
              color: #999999 !important;
            }
          }
        }

        .video_speed {
          float: right;
        }
      }

      .speed {
        display: inline-block;
        width: 260px;
        background: #ffffff;
        margin-top: 10px;

        .speend_title {
          border-bottom: 1px solid #f5f5f5;
          width: 234px;
          margin: 0 auto;

          .speend_title_txt {
            font-size: 18px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 16px;
            letter-spacing: 0px;
            color: #7a818b;
            margin: 24px 0 20px 0;
            padding-left: 10px;
            border-left: 4px solid #7a818b;
          }
        }

        .circle_wrap_no_test {
          height: 220px !important;
        }

        .circle_wrap {
          text-align: center;
          position: relative;
          width: 234px;
          margin: 0 auto;
          margin-bottom: 30px;
          min-height: 440px;

          .progress_wrap {
            margin-top: 40px;

            .progress_title {
              font-weight: 400;
              font-size: 16px;
              color: #7a818b;
              text-align: left;
              margin-bottom: 30px;
            }

            .ought_time {
              font-weight: 400;
              font-size: 14px;
              color: #df3031;
              line-height: 17px;
              margin-top: 8px;
            }

            .free_time {
              font-weight: 400;
              font-size: 13px;
              color: #AAAAAA;
              line-height: 23px;
              margin: 30px 0;
            }

            .exam_number {
              font-weight: 400;
              font-size: 14px;
              color: #7e858f;
              line-height: 17px;
              margin-top: 14px;
            }
          }

          .video_number {
            .title {
              font-size: 12.8px;
              font-weight: 400;
              font-stretch: normal;
              line-height: 20px;
              letter-spacing: 2.6px;
              color: #ff9a88;
            }

            .txt {
              font-size: 30px;
              font-weight: 400;
              font-stretch: normal;
              line-height: 50px;
              letter-spacing: 0px;
              color: #ff9a88;
            }
          }

          .answer_number {
            text-align: center;
            width: 150px;

            .title {
              font-size: 12.8px;
              font-weight: normal;
              font-stretch: normal;
              line-height: 20px;
              letter-spacing: 2.6px;
              color: #ffa72e;
            }
          }

          .time_wrap {
            color: #0088e8;

            .time_count {
              margin-top: 7px;
              font-size: 24px;
              font-weight: 700;
              --tw-text-opacity: 1;
              color: rgb(65 142 198 / var(--tw-text-opacity, 1));
            }

            .time {
              font-weight: 800;
              font-size: 36px;
              color: #418ec6;
              line-height: 30px;
            }

            .time_txt {
              font-weight: 500;
              font-size: 16px;
              color: #7a818b;
              line-height: 46px;
            }
          }

          .answer_txt {
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 36px;
            letter-spacing: 0px;
            color: #ff9d00;
            position: absolute;
            top: 388px;
            left: 0;
            right: 0;
            text-align: center;
          }
        }
      }

      .card {
        width: 250px;
        background: #72abd5;
        border-radius: 14px;
        margin-top: 60px;
        margin: 10px auto;
        text-align: center;
        padding: 10px 0;

        p {
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 30px;
          letter-spacing: 1px;
          color: #ffffff;
        }
      }

      .advert {
        width: 100%;
        margin: 5px 0;

        img {
          width: 100%;
          margin-top: 5px;
          cursor: pointer;
        }
      }

      .advert_ebook {
        width: 100%;
        margin: 5px 0;

        img {
          width: 100%;
          margin-top: 5px;
        }
      }
    }
  }
}

.scan_title {
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 45px;
  letter-spacing: 2px;
  color: #000000;

  span {
    vertical-align: middle;
    display: inline-block;
    margin-left: 6px;
  }

  i {
    color: #37e010;
    font-size: 22px;
    vertical-align: middle;
  }
}

.scan_center {
  text-align: center;

  .img_wrap {
    display: inline-block;
    box-shadow: #000000 0px 0px 6px;
    vertical-align: middle;

    img {
      vertical-align: top;
      width: 80px;
    }
  }

  .txt_wrap {
    display: inline-block;
    width: 60%;
    vertical-align: middle;
    margin-left: 20px;
    text-align: left;

    p {
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 24px;
      letter-spacing: 0px;
      color: #000000;
    }
  }
}

.flex_right {
  position: fixed;
  right: 0;
  top: 470px;
  box-shadow: #ebebeb 0px 0px 10px;
  width: 83px;

  .sub_wrap {
    position: relative;
    background-color: #ffffff;
    text-align: center;
    padding: 16px 0;

    .sub_show {
      cursor: pointer;

      i {
        font-size: 24px;
        color: #5c90bf;
      }

      p {
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 1px;
        color: #7a818b;
        margin: 12px 0;
      }

      .code {
        display: none;
        position: absolute;
        top: -134px;
        background: #179eba;
        width: 73px;
        padding: 10px 5px;

        i {
          color: #ffffff;
          margin-bottom: 8px;
          display: inline-block;
        }

        p {
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 26px;
          letter-spacing: 0px;
          color: #ffffff;
          margin: 0;
        }

        .pop {
          position: absolute;
          left: -206px;
          top: -18px;
          background-color: #179eba;
          width: 170px;
          text-align: center;
          padding: 10px;

          img {
            width: 138px;
          }

          p {
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 24px;
            letter-spacing: 0px;
            color: #ffffff;
            margin: 0;
            margin-top: 10px;
          }

          .triangle {
            display: block;
            margin: 10px auto;
            width: 0;
            height: 0;
            border: 10px solid transparent;
            border-left-color: #179eba;
            position: absolute;
            top: 84px;
            right: -20px;
          }
        }
      }

      &:hover {
        .code {
          display: block;
        }
      }
    }

    .go_top {
      cursor: pointer;

      i {
        font-size: 24px;
        color: #5c90bf;
      }

      p {
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 1px;
        color: #7a818b;
        margin-top: 12px;
      }
    }
  }
}

.xcx_img {
  width: 160px;
}

.el-dropdown-menu__item {
  display: block !important;
}

.messageIndex {
  z-index: 99999;
}

.ccH5hdul {
  right: 84px !important;
}

.ccH5spul {
  right: 155px !important;
}

.el-tooltip__trigger {
  outline: none !important;
}

.hide-open-icon {
  .el-icon {
    display: none !important;
  }

  .video_title {
    width: 408px !important;
  }

  .exam {
    width: 118px !important;
  }
}
</style>
